import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  maxHeight,
  MaxHeightProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & MaxHeightProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.7')}px;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${themeGet('colors.background.screen')};

  svg {
    width: 25px;
    height: 25px;
    color: ${themeGet('colors.primary.main')};
  }

  ${flexDirection}
  ${maxHeight}
`

export const ImageHolder = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-height: 300px;
  background-color: ${themeGet('colors.background.screenAlt')};

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left top;
  }
`

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.2')}px;
  color: ${themeGet('colors.primary.main')};

  &:hover {
    color: ${themeGet('colors.primary.dark')};
  }
`
